import React from "react";
import { HelpingIcon } from "../../../Icons";
import { referralApi } from "../../../services/librariesCatalogService";
import LibraryCatalogPage, {
  cellMuted,
} from "../components/LibraryCatalogPage";
import ReferralFormModal from "./ReferralFormModal";

const columns = [
  {
    header: "Referral Name",
    accessor: "referralName",
    sortable: true,
    strong: true,
    className: "whitespace-nowrap px-3 min-w-[10rem]",
  },
  { header: "Category", accessor: "category", sortable: true },
  {
    header: "Code",
    accessor: "code",
    sortable: true,
    render: (row) => (
      <span className={`${cellMuted} tabular-nums`}>{row.code || "—"}</span>
    ),
  },
];

const ReferralSourcesPage = () => (
  <LibraryCatalogPage
    title="Referral Sources"
    icon={HelpingIcon}
    addLabel="Create New"
    searchPlaceholder="Search by name, category, code..."
    entityLabel="Referral source"
    defaultSortBy="referralName"
    api={referralApi}
    columns={columns}
    FormModal={ReferralFormModal}
    getDeleteLabel={(row) => row.referralName}
  />
);

export default ReferralSourcesPage;
